import React, { useState, useMemo } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import DashboardHeader from "../components/DashboardHeader";
import SummaryStats from "../components/SummaryStats";
import FinancialChart from "../components/FinancialChart";
import FinancialCards from "../components/FinancialCards";
import DistributionCharts from "../components/DistributionCharts";
import PendingTransactionsTable from "../components/PendingTransactionsTable";

export default function Home() {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    const saved = localStorage.getItem("sidebarCollapsed");
    return saved !== null ? JSON.parse(saved) : true;
  });

  const userData = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("user_data") || "{}");
    } catch {
      return {};
    }
  }, []);
  const isAdmin = userData?.is_admin === true;

  const currentYear = new Date().getFullYear();
  const [appliedRange, setAppliedRange] = useState({
    startMonth: `${currentYear}-01`,
    endMonth: `${currentYear}-12`,
  });

  return (
    <div className="flex min-h-screen bg-slate-50 font-sans">
      <div
        className={`fixed inset-y-0 left-0 z-50 transition-all duration-300 pointer-events-none md:pointer-events-auto ${isSidebarCollapsed ? "w-16" : "w-48"}`}>
        <Sidebar
          isCollapsed={isSidebarCollapsed}
          onToggle={() =>
            setIsSidebarCollapsed((prev) => {
              const newState = !prev;
              localStorage.setItem(
                "sidebarCollapsed",
                JSON.stringify(newState),
              );
              return newState;
            })
          }
          activePage="beranda"
        />
      </div>

      <div
        className={`flex-1 flex flex-col min-w-0 transition-all duration-300 ${isSidebarCollapsed ? "ml-16" : "ml-48"}`}>
        <Header
          isSidebarCollapsed={isSidebarCollapsed}
          onToggleSidebar={() =>
            setIsSidebarCollapsed((prev) => {
              const newState = !prev;
              localStorage.setItem(
                "sidebarCollapsed",
                JSON.stringify(newState),
              );
              return newState;
            })
          }
        />

        <main className="flex-1 p-6 overflow-x-hidden overflow-y-auto">
          {/* Top Section: Welcome & Stats */}
          <div className="flex flex-col md:flex-row gap-6 mb-8 items-stretch">
            <div className="flex-1 flex flex-col">
              <DashboardHeader />
            </div>
            <div className="w-full md:w-[436px] flex-shrink-0 flex flex-col">
              <SummaryStats appliedRange={appliedRange} />
            </div>
          </div>

          {/* Charts & Data */}
          {isAdmin && (
            <FinancialChart
              appliedRange={appliedRange}
              onApplyRange={setAppliedRange}
            />
          )}
          <FinancialCards appliedRange={appliedRange} />
          <DistributionCharts appliedRange={appliedRange} />
          <PendingTransactionsTable appliedRange={appliedRange} />
        </main>
      </div>
    </div>
  );
}
